import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "custom-component submit-btn"
};
var _hoisted_2 = {
  class: "header"
};
var _hoisted_3 = {
  class: "body"
};
var _hoisted_4 = {
  class: "footer"
};
var _hoisted_5 = {
  class: "sub-type"
};
import commonTxt from './commonTxt.vue';

/* 工具 */
import { computed, onMounted } from 'vue';
import { isJson } from '@/utils/index';

/* 变量 */

export default {
  __name: 'eSubmit',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    _useCssVars(function (_ctx) {
      return {
        "v134432df": backgroundColor.value
      };
    });

    /* 组件 */
    var props = __props;
    var submitTypeOptions = [
    // {
    //   label: '手写',
    //   value: 'write',
    // },
    // {
    //   label: '拍照',
    //   value: 'photograph',
    // },
    // {
    //   label: '上传文件',
    //   value: 'upload',
    // },
    // {
    //   label: '截屏',
    //   value: 'screenshot',
    // },
    // {
    //   label: '打卡',
    //   value: 'clockIn',
    // },
    // {
    //   label: '思维导图',
    //   value: 'MindMapping',
    // },
    {
      label: '打卡',
      value: 'clockIn',
      disabled: false,
      content: '选择打卡形式后不能选择其它形式；且发布后无法修改提交形式'
    }, {
      label: '图文',
      value: 'picture',
      disabled: false,
      content: '学生可以文本、手写输入、截取、上传图片或思维导图'
    }, {
      label: '文档',
      value: 'file',
      disabled: false,
      content: '学生可以上传word、pdf、excel、txt等文档'
    }];
    var emit = __emit;

    /* 计算属性 */
    var backgroundColor = computed(function () {
      return props.elementContent.submit && props.elementContent.submit.color ? props.elementContent.submit.color : '#ffa63a';
    });
    var submitType = computed(function () {
      var suitTyoe = submitTypeOptions.filter(function (item) {
        return props.elementContent.submit && props.elementContent.submit.submitType.indexOf(item.value) > -1;
      }).map(function (item) {
        return item.label;
      }).join(',');
      return suitTyoe;
    });
    var contentData = computed(function () {
      if (props.elementContent.content && isJson(props.elementContent.content)) {
        var _JSON$parse = JSON.parse(props.elementContent.content),
          content = _JSON$parse.content;
        return content;
      }
      return props.elementContent.content;
    });
    onMounted(function () {
      emit('loaded', 'eSubmit');
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_svg_icon, {
        name: "course-submit"
      }), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "svg-middel span-class"
      }, "提交", -1))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "sub-btn"
      }, null, -1))]), _createElementVNode("div", _hoisted_3, [_createVNode(commonTxt, {
        "initial-content": contentData.value
      }, null, 8, ["initial-content"])]), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "progress-class"
      }, [_createElementVNode("span", null, "进度")], -1)), _createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("span", null, "提交形式:", -1)), _createElementVNode("span", null, _toDisplayString(submitType.value), 1)])])]);
    };
  }
};